module.exports = __webpack_public_path__ + "static/media/gradient-shape.7d5fc2ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gradient-shape.svg
// module id = 1757
// module chunks = 0